export default "__VITE_PUBLIC_ASSET__faaeec72__"